import { IAppSwitcherModalService } from "./i-app-switcher-modal.service";
import { Inject, Injectable } from "@angular/core";
import { IModalService, modalServiceInjectionToken } from "@zaeper/angular-dashboard-view-lib";
import { AppSwitcherModalComponent } from "./app-switcher-modal.component";

@Injectable()
export class AppSwitcherModalService implements IAppSwitcherModalService {
  constructor(@Inject(modalServiceInjectionToken) private readonly _modalService: IModalService) {
  }

  public open(): void {
    this._modalService.open(AppSwitcherModalComponent, {
      styleClass: 'bg-white rounded-lg overflow-hidden',
      header: "App wechseln",
      showHeader: true,
      closable: true,
      width: '700px',
      closeOnEscape: true,
      dismissableMask: true
    });
  }
}
